// Helper function to update model info based on active slide
function updateModelInfo(activeSlider) {
  var activeProductId = activeSlider.find('.slick-slide.slick-active .fit-guide-image-item').data('product-id');
  var activeSize = $('.product-detail__media-slider .slick-slide.slick-active .fit-guide-image-item[data-product-id="' + activeProductId + '"]').data('size');
  $('.fit-guide-image-item-model').hide();
  $('.fit-guide-image-item-model[data-product-id="' + activeProductId + '"][data-size="' + activeSize + '"]').show();
}

// Create constants for common configurations
var commonArrows = {
  prevArrow:
    '<div class="slick-slider__prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></div>',
  nextArrow:
    '<div class="slick-slider__next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></div>',
};

// Media slider settings
const mediaSliderSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  lazyLoad: 'ondemand',
  adaptiveHeight: false
};

// Nav slider settings
const navSliderSettings = {
  slidesToShow: 6,
  slidesToScroll: 1,
  focusOnSelect: true,
  arrows: false,
  centerMode: false,
  variableWidth: true
};

const categorySlickSettings = {
  slidesToShow: 7,
  slidesToScroll: 1,
  centerPadding: '100px',
  arrows: true,
  ...commonArrows,
  dots: false,
  infinite: true,
  centerMode: true,
  lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}
// Get all tab buttons and tab content containers
var tabButtons = document.querySelectorAll('.category-slider-tab');
var tabContents = document.querySelectorAll('.category-slider-tab-content');

// Set up click event for each tab button
tabButtons.forEach(function(btn, idx) {
  btn.addEventListener('click', function() {
    // Remove 'active' class from all tabs and contents
    tabButtons.forEach(function(b) { b.classList.remove('active'); });
    tabContents.forEach(function(tc) { tc.classList.remove('active'); });
    // Activate the clicked tab and its content
    btn.classList.add('active');
    tabContents[idx].classList.add('active');
    // Find the slider in the active tab content
    var slider = tabContents[idx].querySelector('.category-slider');
    // Only initialise Slick if it hasn't been already
    if (slider && !slider.classList.contains('slick-initialized')) {
      $(slider).slick({
        ...categorySlickSettings
      })
      .on('afterChange', handleSliderAfterChange);
    }
    // Automatically select the first thumb in the tab
    var firstThumb = tabContents[idx].querySelector('.category-slider__product-thumb');
    if (firstThumb) {
      firstThumb.click();
    }
  });
});

// Handle clicks on product thumbs using event delegation
// This means even cloned thumbs from Slick will work
function handleThumbClick(e) {
  var thumb = e.target.closest('.category-slider__product-thumb');
  // Ignore clicks that aren't on a thumb
  if (!thumb) return;
  // Find the parent tab content for context
  var tabContent = thumb.closest('.category-slider-tab-content');
  if (!tabContent) return;
  // Deselect all thumbs, then select the clicked one
  var thumbs = tabContent.querySelectorAll('.category-slider__product-thumb');
  thumbs.forEach(function(t) { t.classList.remove('selected'); });
  thumb.classList.add('selected');
  // Get the index of the product from the thumb's data attribute
  var prodIdx = parseInt(thumb.getAttribute('data-product-index'));
  var thumbIdx = thumb.closest('.slick-slide').getAttribute('data-slick-index') 

  // Move the main slider to the selected product
  var slider = tabContent.querySelector('.category-slider');
  if (slider && $(slider).hasClass('slick-initialized')) {
    $(slider).slick('slickGoTo', thumbIdx);
  }
  // Hide all product content panels, then show the selected one
  tabContent.querySelectorAll('.category-slider__product-content').forEach(function(panel) {
    panel.classList.remove('active');
  });
  var contentPanel = tabContent.querySelector('.category-slider__product-content[data-product-content-index="' + prodIdx + '"]');
  if (contentPanel) {
    contentPanel.classList.add('active');
    // If the product has a media slider with more than one image, initialise Slick for it
    var mediaSlider = contentPanel.querySelector('.product-detail__media-slider');
    if (mediaSlider && mediaSlider.children.length > 1) {
      var $mediaSlider = $(mediaSlider);
      var $nav = $(mediaSlider).closest('.product-detail__image').find('.see-it-on-toolbar');

      // Unslick if already initialized
      if ($mediaSlider.hasClass('slick-initialized')) $mediaSlider.slick('unslick');
      if ($nav.length && $nav.hasClass('slick-initialized')) $nav.slick('unslick');

      // Initialize both, if nav exists and has children
      if ($nav.length && $nav.children().length > 0) {
        $mediaSlider.slick({
          ...mediaSliderSettings,
          asNavFor: $nav
        })
        .on('init', function(event, slick, currentSlide){
          updateModelInfo($(event.currentTarget));
        })
        .on('afterChange', function(event, slick, currentSlide){
          updateModelInfo($(event.currentTarget));
        });
        $nav.slick({
          ...navSliderSettings,
          asNavFor: $mediaSlider
        });
      } else {
        // Fallback: just initialize the media slider
        $mediaSlider.slick({
          ...mediaSliderSettings
        })
        .on('init', function(event, slick, currentSlide){
          updateModelInfo($(event.currentTarget));
        })
        .on('afterChange', function(event, slick, currentSlide){
          updateModelInfo($(event.currentTarget));
        });
        $nav.hide();
      }
    }
  }
}

// Handler for Slick afterChange event to activate the correct tab-content and thumb
function handleSliderAfterChange(event, slick, currentSlide) {
  // Find the parent tab content
  var tabContent = slick.$slider.closest('.category-slider-tab-content')[0];
  if (!tabContent) return;

  // Deselect all thumbs, then select the one matching the current slide
  var thumbs = tabContent.querySelectorAll('.category-slider__product-thumb');
  thumbs.forEach(function(t) { t.classList.remove('selected'); });

  // Find the thumb with the matching data-slick-index
  var selectedThumb = Array.from(tabContent.querySelectorAll('.slick-slide[data-slick-index="' + currentSlide + '"] .category-slider__product-thumb')).pop();
  if (selectedThumb) {
    selectedThumb.classList.add('selected');
  }

  // Hide all product content panels, then show the selected one
  tabContent.querySelectorAll('.category-slider__product-content').forEach(function(panel) {
    panel.classList.remove('active');
  });

  // Get the product index from the thumb or slide
  var prodIdx = selectedThumb ? selectedThumb.getAttribute('data-product-index') : currentSlide;
  var contentPanel = tabContent.querySelector('.category-slider__product-content[data-product-content-index="' + prodIdx + '"]');
  if (contentPanel) {
    contentPanel.classList.add('active');
    // If the product has a media slider with more than one image, initialise Slick for it
    var mediaSlider = contentPanel.querySelector('.product-detail__media-slider');
    if (mediaSlider && mediaSlider.children.length > 1) {
      var $mediaSlider = $(mediaSlider);
      var $nav = $(mediaSlider).closest('.product-detail__image').find('.see-it-on-toolbar');

      // Unslick if already initialized
      if ($mediaSlider.hasClass('slick-initialized')) $mediaSlider.slick('unslick');
      if ($nav.length && $nav.hasClass('slick-initialized')) $nav.slick('unslick');

      // Initialize both, if nav exists and has children
      if ($nav.length && $nav.children().length > 0) {
        $mediaSlider.slick({
          ...mediaSliderSettings,
          asNavFor: $nav
        })
        .on('init', function(event, slick, currentSlide){
          updateModelInfo($(event.currentTarget));
        })
        .on('afterChange', function(event, slick, currentSlide){
          updateModelInfo($(event.currentTarget));
        });
        $nav.slick({
          ...navSliderSettings,
          asNavFor: $mediaSlider
        });
      } else {
        // Fallback: just initialize the media slider
        $mediaSlider.slick({
          ...mediaSliderSettings
        })
        .on('init', function(event, slick, currentSlide){
          updateModelInfo($(event.currentTarget));
        })
        .on('afterChange', function(event, slick, currentSlide){
          updateModelInfo($(event.currentTarget));
        });
        $nav.hide();
      }
    }
  }
}

// Keyboard activation for role="button" elements — WCAG 2.1.1
// Fires the element's click handler on Enter/Space, matching native button behaviour.
function handleButtonKeydown(e) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    e.target.click();
  }
}

// Attach the event delegation handler to each slider in each tab content
document.querySelectorAll('.category-slider-tab-content').forEach(function(tabContent) {
  var slider = tabContent.querySelector('.category-slider');
  if (slider) {
    slider.addEventListener('click', handleThumbClick);
    slider.addEventListener('keydown', handleButtonKeydown);
  }
  // On page load, select the first thumb and show its content by default
  var thumbs = tabContent.querySelectorAll('.category-slider__product-thumb');
  if (thumbs.length > 0) {
    thumbs[0].classList.add('selected');
    var firstPanel = tabContent.querySelector('.category-slider__product-content[data-product-content-index="0"]');
    if (firstPanel) {
      firstPanel.classList.add('active');
      var mediaSlider = firstPanel.querySelector('.product-detail__media-slider');
      if (mediaSlider && mediaSlider.children.length > 1) {
        var $mediaSlider = $(mediaSlider);
        var $nav = $(mediaSlider).closest('.product-detail__image').find('.see-it-on-toolbar');

        // Unslick if already initialized
        if ($mediaSlider.hasClass('slick-initialized')) $mediaSlider.slick('unslick');
        if ($nav.length && $nav.hasClass('slick-initialized')) $nav.slick('unslick');

        // Initialize both, if nav exists and has children
        if ($nav.length && $nav.children().length > 0) {
          $mediaSlider.slick({
            ...mediaSliderSettings,
            asNavFor: $nav
          })
          .on('init', function(event, slick, currentSlide){
            updateModelInfo($(event.currentTarget));
          })
          .on('afterChange', function(event, slick, currentSlide){
            updateModelInfo($(event.currentTarget));
          });
          $nav.slick({
            ...navSliderSettings,
            asNavFor: $mediaSlider
          });
        } else {
          // Fallback: just initialize the media slider
          $mediaSlider.slick({
            ...mediaSliderSettings
          })
          .on('init', function(event, slick, currentSlide){
            updateModelInfo($(event.currentTarget));
          })
          .on('afterChange', function(event, slick, currentSlide){
            updateModelInfo($(event.currentTarget));
          });
          $nav.hide();
        }
      }
    }
  }
});

// On initial page load, set up the first slider (the one in the active tab)
var firstSlider = document.querySelector('.category-slider-tab-content.active .category-slider');
if (firstSlider && !firstSlider.classList.contains('slick-initialized')) {
  $(firstSlider).slick({
    ...categorySlickSettings
  })
  .on('afterChange', handleSliderAfterChange);
}
// Automatically select the first thumb in the active tab on page load
var firstThumb = document.querySelector('.category-slider-tab-content.active .category-slider__product-thumb');
if (firstThumb) {
  firstThumb.click();
}

// WCAG 2.1.1: keyboard activation for see-it-on-btn elements (role="button")
// Delegates on the section so cloned Slick slides are covered.
document.querySelectorAll('.category-slider-section').forEach(function(section) {
  section.addEventListener('keydown', function(e) {
    if (e.target.classList.contains('see-it-on-btn')) handleButtonKeydown(e);
  });
});
